module.exports = __webpack_public_path__ + "img/num03_white.710e79a6.svg";